import {Component} from '@angular/core';

@Component({
    selector: 'app-masked-aadhaar-info',
    templateUrl: './masked-aadhaar-info.component.html',
    styleUrls: ['./masked-aadhaar-info.component.scss']
})
export class MaskedAadhaarInfoComponent {
}